import { z } from 'zod';
import type { UserDTO } from './user.js';
import type { Permission, Role } from './roles.js';

/**
 * Login request body. The `initData` is the raw, unmodified query string
 * provided by the Telegram Mini App (`window.Telegram.WebApp.initData`).
 * The backend verifies its HMAC signature before trusting anything in it.
 */
export const loginSchema = z
  .object({
    initData: z.string().min(1, 'initData is required'),
  })
  .strict();

export type LoginInput = z.infer<typeof loginSchema>;

/** Successful login / session response. */
export interface AuthResponse {
  token: string;
  user: UserDTO;
  permissions: Permission[];
}

/** Decoded JWT session payload stored in the access token. */
export interface SessionPayload {
  /** Internal user id. */
  sub: string;
  telegramId: string;
  role: Role;
}
